import styled, { css } from 'styled-components';
import { Icon, mainTheme } from '@plecto/ui';

// The Menu's row height, same as the compact dropdown rows elsewhere.
const MENU_ITEM_HEIGHT = 36;

// A row in the UI library's Menu: the panel owns the surface, the row is bare
// until the pointer washes it, and the wash is a rounded rectangle rather than a
// band. Repainting menu.default on every row is what made it a band — the row
// covered the panel edge to edge, so a radius had nothing to round against.
export const StyledDropdownItem = styled.li`
	cursor: pointer;
	display: flex;
	align-items: center;
	background-color: transparent;
	border-radius: 2px;
	min-height: ${MENU_ITEM_HEIGHT}px;
	${props => props.selected ? css`
		// menu.selected is a text token. Set as a background it painted the whole
		// row near-white; it marks the label instead.
		color: ${mainTheme.form.dropdown.menu.selected};
	` : ''}
	${props => props.selectable ? css`
		&:hover {
			background-color: ${mainTheme.form.dropdown.menu.hover.background};
			box-shadow: ${mainTheme.shadow.inset};
			color: ${mainTheme.form.dropdown.menu.hover.color};
		}
	` : ''}
`;

export const StyledDropdownInfo = styled(StyledDropdownItem)`
	text-align: stretch;
	color: ${mainTheme.text.tertiary};
	padding: 0 6px;
	cursor: auto;
`;

export const StyledDropdownItemTitle = styled.div`
	flex: 1 0;
`;

export const StyledDropdownIcon = styled(Icon)`
	flex: 0 1;
	padding: 6px 10px;
	line-height: 1.4;
`;

export const StyledDropdownArrow = styled(Icon)`
	flex: 0 1;
	padding: 6px 10px;
	align-items: center;
	display: flex;
	cursor: pointer;
	&:hover {
		background-color: ${mainTheme.form.dropdown.menu.hover.background};
	}
`;
